import { render, staticRenderFns } from "./Etapa3.vue?vue&type=template&id=89dcd85a&scoped=true"
import script from "./Etapa3.vue?vue&type=script&lang=js"
export * from "./Etapa3.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=89dcd85a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dcd85a",
  null
  
)

export default component.exports